<template>
    <div id="stockist-list" class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="gmap">
                    <gmap-map
                        v-if="initialized"
                        :key="center.timestamp"
                        :center="center.position"
                        :zoom="center.zoom"
                        :options="mapOptions"
                        style="width:100%;  height: 100%;">
                        <gmap-marker
                            v-for="marker in stocklistDisplay"
                            v-on:click="() => { currentStocklistId = marker.id; $forceUpdate() }"
                            :key="`marker${marker.id}`"
                            :icon="getBrandMarker(marker)"
                            :position="marker.location.position"
                            :clickable="true"
                            :draggable="false">
                            <gmap-info-window
                                v-on:closeclick="() => { currentStocklistId = null; $forceUpdate() }"
                                :opened="marker.id == currentStocklistId">
                                <div class="card mb-0" v-html="getStocklistInfo(marker, true)"></div>
                            </gmap-info-window>
                        </gmap-marker>
                    </gmap-map>
                </div>
                <div class="key">
                    <span><img src="/img/site/icons/env-pin.svg" alt="Map Pin for Environ stockists">Environ</span>
                    <span><img src="/img/site/icons/jane-pin.svg" alt="Map Pin for Jane Iredale stockists">Jane Iredale</span>
                    <span><img src="/img/site/icons/brands-pin.svg" alt="Map Pin for All Brands">All Brands</span>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="bg-grey">
                    <div class="stockist-filter">
                        <form action="" class="form-inline">
                            <label for="" >Find Brand:</label>
                            <label v-for="brandOption in _.keys(brandMap)" class="container-checkbox"
                                :key="`brand${brandOption}`">
                                <input type="checkbox" v-model="brandMap[brandOption]">
                                <span class="checkmark"></span>
                                {{ brands[brandOption] }}
                            </label>

                            <div class="region">
                                <img src="/img/site/icons/target-bk.svg" class="target" alt="Region">
                                <select v-model="region" class="selectpicker" data-style="btn-select" data-width="100%">
                                    <option value="">All Regions</option>
                                    <option data-divider="true"></option>
                                    <option v-for="region in regions"
                                        :value="region.name"
                                        :key="`region-${region.name}`">
                                        {{ region.name }}
                                    </option>
                                </select>
                            </div>
                        </form>


                        <div v-if="_.get(stocklist, 'length') <= 0" class="no-results">
                            <p class="text-center">Please select a region to begin your search</p>
                        </div>

                        <!-- Start List -->
                        <!-- <div v-else-if class="list">
                        </div> -->
                        <div v-else class="list">
                            <h2 class="px-3">{{ region || 'All regions' }}</h2>

                            <template  v-if="_.isNull(region) || _.isEmpty(region)">
                                <div class="row" v-for="(region,idx) in listByRegion" :key="`region${idx}`">
                                    <template v-if="region.stocklist.length > 0">
                                    <div class="col-sm-12">
                                        <h2 class="region-name px-3">
                                            {{ region.name }}
                                        </h2>
                                    </div>
                                    <div v-for="stocklist in region.stocklist"
                                        :key="`regionStockistId-${stocklist.id}`"
                                        class="col-sm-6">
                                        <div class="card flex-column align-items-start">
                                            <h3><a href="javascript:void(0)" v-on:click="navigateToStocklist(stocklist)">{{ stocklist.name }}</a></h3>

                                            <div v-html="getStocklistInfo(stocklist)"></div>
                                        </div>
                                    </div>
                                    </template>
                                </div>
                            </template>
                            <div v-else class="row">
                                <div v-for="stocklist in stocklistDisplay"
                                    :key="`stocklistId-${stocklist.id}`"
                                    class="col-sm-6">
                                    <div class="card">
                                        <h3><a href="javascript:void(0)" v-on:click="navigateToStocklist(stocklist)">{{ stocklist.name }}</a></h3>

                                        <div v-html="getStocklistInfo(stocklist)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End list -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import UtilsMixin from './UtilsMixin';
// import GMaps from 'gmaps';

const defaultMarker = {
    timestamp: Date.now(),
    zoom: 5,
    position: { lat: -41.95804878921898, lng: 174.88597099999993 },
};

export default {
    data() {
        const brands = {
            ['environ.private']: 'Environ',
            ['jane_iredale.private']: 'Jane Iredale',
        };
        const regions = ['Auckland', 'Hamilton'];
        const center = defaultMarker;

        return {
            initialized: false,
            search: '',
            region: '',
            brands,
            brandMap: _.chain(brands)
                .toPairs()
                .map(([scope, brand]) => ([scope, false]))
                .fromPairs().value(),

            mapOptions: {},
            center,
            stocklistDisplay: [],
            currentStocklistId: null,
        }
    },

    mounted() {
        this.mapOptions =  {
            disableDefaultUI: true,
            mapTypeControl: false,
            scaleControl: true,
            zoomControl: true,
            fullscreenControl: true,
            zoomControlOptions: {
                // style: google.maps.ZoomControlStyle.LARGE
            },
        };

        const params = new URLSearchParams(window.location.search);
        if (params.has('brand') && _.includes(['environ', 'jane_iredale'], params.get('brand'))) {
            this.brandMap[params.get('brand') + '.private'] = true;
        }

        this.geolocate();
        this.initialized = true;
        $(".gmap").sticky({ topSpacing: 60 });

        // $('.gmap').on('sticky-update', function() { console.log("Update"); });
    },

    props: ['initialData'],

    mixins: [UtilsMixin],

    watch: {
        filteredList: {
            handler(newList) {
                this.stocklistDisplay = _.map(newList, (st) => ({
                    ...st, location: this.getLocationMarker(st.b_location),
                }));
            },
            deep: true,
            immediate: true,
        },

        region(newVal) {
            if (!newVal) return;

            const region = this.regions.find((rg) => _.lowerCase(newVal) == _.lowerCase(rg.name));
            const position = region.location.split(',');
            const location = {
                lat: parseFloat(position[0]),
                lng: parseFloat(position[1]),
            };
            this.center = {
                timestamp: Date.now(),
                zoom: 8,
                position: location,
            };
            this.$forceUpdate();
        },
    },

    computed: {
        stocklist() {
            return _.get(this.initialData, 'stocklist', []);
        },

        listByRegion() {
            return this.regions.map((rg) => {
                let stocklist = this.filteredList
                    .filter(item => {
                        return _.lowerCase(item.b_region) == _.lowerCase(rg.name);
                    })
                    .map((st) => {
                        return {
                            ...st,
                            location: this.getLocationMarker(st.b_location),
                        }
                    });
                return {
                    name: rg.name,
                    stocklist: stocklist
                }
            });
        },

        filteredList() {
            const selectedScopes = _.chain(this.brandMap)
                .toPairs()
                .filter(([_, checked]) => checked)
                .map(([name]) => name)
                .value();

            return _.chain(this.stocklist)
                .filter(item => {
                    let pass = true;
                    if (this.region && pass) {
                        pass = (_.lowerCase(item.b_region) == _.lowerCase(this.region));
                    }

                    if (selectedScopes.length && pass) {
                        const intersected = _.chain(item.scopes).intersection(selectedScopes, item.scopes).get('length').value();
                        pass = intersected && intersected <= _.values(selectedScopes).length;
                        // pass = _.intersection(selectedScopes, item.scopes).length <= _.values(selectedScopes).length;
                    }
                    return pass;
                })
                .sort((a, b) => a.ranking-b.ranking)
                .value();
        },
        regions() {
            return _.chain(this.stocklist)
                .filter(st => {
                    return !_.isNull(st.b_location) ? st : false;
                })
                .map(st => {
                    let location = st.b_location.split(',');
                    return {
                        name: _.toUpper(_.trim(st.b_region)),
                        location: st.b_location,
                        distance: this.getDistance(0, 180, location[0], location[1]),
                    }
                })
                .uniqBy('name')
                .sort((a, b) => a.distance-b.distance)
                .value();
        },

    },

    methods: {

        getDistance(lat1, lon1, lat2, lon2) {
            var radlat1 = Math.PI * lat1/180;
            var radlat2 = Math.PI * lat2/180;
            var theta = lon1-lon2;
            var radtheta = Math.PI * theta/180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344 ;

            return dist;
        },

        sortByRanking(a, b) {
            return a.ranking - b.ranking;
        },

        getAddress(record) {
            const region = [
                _.get(record, 'b_suburb'),
                _.get(record, 'b_city'),
                _.get(record, 'b_postcode'),
            ].filter(Boolean).join(' ');

            return [_.get(record, 'b_street'), region].join('<br>');
        },

        // receives a place object via the autocomplete component
        geolocate() {
            navigator.geolocation.getCurrentPosition(position => {
                const location = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                this.center = {
                    timestamp: Date.now(),
                    zoom: 10,
                    position: location,
                };
            });
        },

        getLocationMarker(value) {
            let marker;
            if (_.isNil(value)) {
                marker = defaultMarker;
            } else if (_.isString(value)) {
                const [lat, lng, zoom] = value.split(/[\,\;\|]/);
                marker = (lat && lng) ?
                    { position: { lat: parseFloat(lat), lng: parseFloat(lng) }, zoom: zoom ? parseInt(zoom) : 10 } : defaultMarker;
            } else if (_.isObject(value)) {
                marker = value;
            } else {
                marker = defaultMarker;
            }

            return marker;
        },

        getLocationValue(location, zoom = 10) {
            if (_.isNil(location)) {
                return '';
            } else if (_.isString(location)) {
                return `${location},${zoom}`;
            } else if (_.isObject(location)) {
                return `${location.lat},${location.lng},${zoom}`;
            } else {
                return '';
            }
        },

        getBrandMarker(item) {
            // console.log(item.scopes);
            const key = _.sumBy(item.scopes, this.getScopeKey);
            switch (key) {
                case 1578:
                    return '/img/site/icons/env-pin.svg';
                case 2044:
                    return '/img/site/icons/jane-pin.svg';
                default:
                    return '/img/site/icons/brands-pin.svg';
            }
        },

        getBrandText(item) {
            const key = _.sumBy(item.scopes, this.getScopeKey);
            const environText = '<span class="orange">Environ</span>';
            const janeText = '<span class="pink">Jane Iredale</span>';

            switch (key) {
                case 1578:
                    return environText;
                case 2044:
                    return janeText;
                default:
                    const parts = [environText, janeText].filter(Boolean);
                    return parts.length ? parts.join(' & ') : '';
            }
        },

        getStocklistInfo(item, header = false) {
            return (header ? `<p class="mb-2">${item.b_region}</p><h3>${item.name}</h3>` : '') +
                `<p class="brand">${this.getBrandText(item)}</p>
                <div class="d-flex">
                    ${item.online_store_environ ? `<a class="btn btn-stockist-map mb-3 px-3 mr-1" href="${item.online_store_environ}" target="_blank">Shop Environ </a>` : ''}
                    ${item.online_store_jane ? `<a class="btn btn-stockist-map mb-3 px-3 mr-1" href="${item.online_store_jane}" target="_blank">Shop jane iredale </a>` : ''}
                </div>
                <p>${this.getAddress(item)}</p>
                <p class="ph">` +
                    (item.phone ? `<a href="tel:${item.phone}">${item.phone}</a><br>` : '') +
                    (item.mobile ? `<a href="tel:${item.mobile}">${item.mobile}</a><br>` : '') +
                    (item.email ? `<a href="mailto:${item.email}">${item.email}</a>` : '') +
                `</p>` +
                (item.website ?
                `<p class="web">
                    <a href="${item.website}" target="_blank"><img src="/img/site/icons/web.svg" alt="www">Visit Website</a>
                </p>` : '');
        },

        navigateToStocklist(item) {
            this.center = item.location;
            this.currentStocklistId = item.id;
            this.$forceUpdate();
        },

        getScopeKey(scope) {
            if (_.includes(scope, '.public')) return 0;
            return _.chain(scope)
                .map(char => char.charCodeAt(0))
                .sum().value();
        }
    }
}
</script>
